import { useTranslationPlus } from '@/Core/i18n/useTranslationPlus';
import FromItemPlus from '@/components/FormItemPlus/FromItemPlus'
import React, { useEffect, useState } from 'react'
import WidthdrawWay from '../compoments/widthdrawWay/WidthdrawWay';
import { IFInitWalletRsp, IFInitWalletWithdrawFlatRsp, IFWithdrawFlatConfigRsp } from '@/api/apiRsp/IFWalletRsp';
import type { FormInstance } from '@/componentsUI/Form';
import InputUI from '@/componentsUI/Input';
import { isCPF, isEmail, isPIXFullName, isPhoneBX } from '@/Core/features/verification';
import './index.less'
import SelectUI, { SelectOption, type OptionInfo } from '@/componentsUI/Select';
import { AmountDivisorConversion, AmountMultiplierConversion, dealAmount0Fiexd } from '@/Core/utils/currencyDealCenter';
import InputWithdrawAmount from '@/components/WalletComp/InputWithdrawAmount';
import InputMaskPlus from '../compoments/inputMask/InputMask';
import WithdrawTaxNotice from '../../components/WithdrawTaxNotice';

interface SelectAccountTypeProps {
    prefixCls?: string;
    onChange?: (value: any, option: OptionInfo | OptionInfo[]) => void;
    options?: any[];
    value?: any;
}

const SelectAccountType = (props: SelectAccountTypeProps) => {
    const { onChange, options, value } = props;

    return (
        <SelectUI className={`select`} value={value} onChange={onChange}>
            {options?.map((item, i) => {
                return (
                    <SelectOption key={i} value={item}>
                        <span>{item}</span>
                    </SelectOption>
                );
            })}
        </SelectUI>
    );
};

const WidthdrawedPix = (props: {
    data: IFWithdrawFlatConfigRsp,
    form: FormInstance<any, any, string | number | symbol>,
    formValidateRef?: any,
    currentWallet?: IFInitWalletRsp;
    widthdrawConfig: IFInitWalletWithdrawFlatRsp
}) => {

    const { data, form, formValidateRef, currentWallet, widthdrawConfig } = props;
    const { t } = useTranslationPlus();

    const [feeAmount, setFeeAmount] = useState('0');
    const currentData = widthdrawConfig;

    //金额校验
    const validatorAmount = (value, cb) => {
        if (!formValidateRef.current) {
            return
        }
        if (!value) {
            return cb(t('Wallet.Wrong Amount'));
        }
        if (!value) {
            return cb('');
        }
        const amount = AmountMultiplierConversion(value, {
            currencyType: currentWallet.currencyType,
        });
        if (
            !amount ||
            amount > currentWallet?.balance ||
            amount < Number(currentData?.singleMinimumCoin) ||
            amount > Number(currentData?.singleMaximumCoin) ||
            amount > Number(data?.availableAmount)
        ) {
            return cb(t('Wallet.Wrong Amount'));
        }

    };

    const refreshFree = (amount) => {
        const withdrawAmount = Number(amount);
        const { adminFee = 0, withdrawalCommission = 0 } = currentData || {};
        const fee = (
            Number(withdrawAmount) * (Number(withdrawalCommission) / 100) +
            AmountDivisorConversion(adminFee, {
                currencyType: currentWallet.currencyType,
            })
        ).toFixed(2);
        setFeeAmount(fee);
    }

    useEffect(()=>{
        if(data?.userAccount?.pixFullName) {
            form.setFieldValue('accountName', data.userAccount.pixFullName)
            form.setFieldValue('cpf', data.userAccount.pixCpf)
            form.setFieldValue('witdrawWay', {
                ...form.getFieldValue('witdrawWay'),
                accountType: data.userAccount.pixType
            });
            form.setFieldValue('account',data.userAccount.pixAccount)
        }
    },[data])

    return (
        <div className='widthdraw-pix'>
            {/* <FromItemPlus */}
            {/*     field={'accountName'} */}
            {/*     label={t('Wallet.AccountHolderName')} */}
            {/*     disabled={true} */}
            {/* > */}
            {/*     <InputUI maxLength={20} /> */}
            {/* </FromItemPlus> */}

            {/* <FromItemPlus */}
            {/*     field={'cpf'} */}
            {/*     label={t('Wallet.PIX_TYPE_CPF')} */}
            {/*     className={'cpf'} */}
            {/*     disabled={true} */}
            {/* > */}
            {/*      <InputUI  maxLength={20} /> */}
            {/* </FromItemPlus> */}

            {/* {<FromItemPlus
                field={'account'}
                className={'cpf'}
                disabled={true}
                label={
                    <div className={`account-type`}>
                        <div className={`account-type-title`}>{t('Wallet.AccountType')+ ' '+ data.userAccount.pixType}</div>
                    </div>
                }
            >
                <InputUI  maxLength={20} />

            </FromItemPlus>} */}

            <FromItemPlus
                field={'amount'}
                label={
                    <div className={`title`}>
                        <span> {t('Wallet.WithdrawAmountTitle') + `(${dealAmount0Fiexd(currentData?.singleMinimumCoin, {
                            currencyType: currentWallet?.currencyType,
                        }) + '-' +
                            dealAmount0Fiexd(currentData?.singleMaximumCoin, {
                                currencyType: currentWallet?.currencyType,
                            })
                            })`} </span>
                    </div>
                }
                rules={[{ validator: validatorAmount }]}
                className={`amount`}
            >
                <InputWithdrawAmount
                    availableAmount = {dealAmount0Fiexd(data.availableAmount, {
                        currencyType: currentWallet?.currencyType
                    })}
                    lockAmount = {
                        dealAmount0Fiexd(data.lockAmount, {
                            currencyType: currentWallet?.currencyType
                        })
                    }
                    balance={AmountDivisorConversion(currentWallet?.balance, {
                        currencyType: currentWallet?.currencyType,
                    })}
                    min={AmountDivisorConversion(currentData?.singleMinimumCoin, {
                        currencyType: currentWallet?.currencyType,
                    })}
                    max={AmountDivisorConversion(currentData?.singleMaximumCoin, {
                        currencyType: currentWallet?.currencyType,
                    })}
                    onChange={(v) => {
                        refreshFree(v);
                    }}
                />
            </FromItemPlus>

            <div className={`fee`}>
                <WithdrawTaxNotice
                    rate={currentData?.withdrawalCommission}
                    amount={feeAmount}
                />
            </div>

        </div>
    )
}

export default WidthdrawedPix
